import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import { XpoChipsModule } from '@xpo-ltl/ngx-ltl-core/chips';
import { XpoDialogModule } from '@xpo-ltl/ngx-ltl-core/dialog';
import { XpoSelectModule } from '@xpo-ltl/ngx-ltl-core/select';
import { XpoCheckboxModule } from '@xpo-ltl/ngx-ltl-core/checkbox';
import { XpoBusyLoaderModule } from '@xpo-ltl/ngx-ltl-core/busy-loader';
import { XpoConfirmDialogModule } from '@xpo-ltl/ngx-ltl-core/confirm-dialog';
import { XpoDownloadButtonModule } from '@xpo-ltl/ngx-ltl-core/download-button';
import { XpoStatusIndicatorModule } from '@xpo-ltl/ngx-ltl-core/status-indicator';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AgGridModule } from 'ag-grid-angular';


import { PipeModule } from '@shared/pipes/pipe.module';
import { MaterialModule } from '@shared/material/material.module';

import { AddRfcDialogComponent } from './add-rfc-dialog/add-rfc-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { EditRfcDialogComponent } from './edit-rfc-dialog/edit-rfc-dialog.component';
import { BothBillDialogComponent } from './both-bill-dialog/both-bill-dialog.component';
import { RemoveRfcDialogComponent } from './remove-rfc-dialog/remove-rfc-dialog.component';
import { DocumentViewDialogComponent } from './document-view-dialog/document-view-dialog.component';
import { RemoveInvoicesDialogComponent } from './remove-invoices-dialog/remove-invoices-dialog.component';
import { ResendInvoicesDialogComponent } from './resend-invoices-dialog/resend-invoices-dialog.component';
import { ReleaseInvoicesDialogComponent } from './release-invoices-dialog/release-invoices-dialog.component';
import { InvoiceNotFoundDialogComponent } from './invoice-not-found-dialog/invoice-not-found-dialog.component';
import { ResendClosedInvoicesDialogComponent } from './resend-closed-invoices-dialog/resend-closed-invoices-dialog.component';

@NgModule({
  declarations: [
    AddRfcDialogComponent,
    ConfirmDialogComponent,
    EditRfcDialogComponent,
    BothBillDialogComponent,
    RemoveRfcDialogComponent,
    DocumentViewDialogComponent,
    RemoveInvoicesDialogComponent,
    ResendInvoicesDialogComponent,
    ReleaseInvoicesDialogComponent,
    InvoiceNotFoundDialogComponent,
    ResendClosedInvoicesDialogComponent,
  ],
  imports: [
    PipeModule,
    FormsModule,
    CommonModule,
    XpoIconModule,
    XpoChipsModule,
    MaterialModule,
    MatDialogModule,
    PdfViewerModule,
    XpoDialogModule,
    XpoSelectModule,
    FlexLayoutModule,
    XpoCheckboxModule,
    ReactiveFormsModule,
    XpoBusyLoaderModule,
    XpoConfirmDialogModule,
    XpoDownloadButtonModule,
    XpoStatusIndicatorModule,
    AgGridModule.withComponents([]),
  ],
  entryComponents: [
    AddRfcDialogComponent,
    ConfirmDialogComponent,
    EditRfcDialogComponent,
    BothBillDialogComponent,
    RemoveRfcDialogComponent,
    DocumentViewDialogComponent,
    RemoveInvoicesDialogComponent,
    ResendInvoicesDialogComponent,
    ReleaseInvoicesDialogComponent,
    InvoiceNotFoundDialogComponent,
    ResendClosedInvoicesDialogComponent
  ],
  exports: [
    AddRfcDialogComponent,
    ConfirmDialogComponent,
    EditRfcDialogComponent,
    BothBillDialogComponent,
    RemoveRfcDialogComponent,
    DocumentViewDialogComponent,
    RemoveInvoicesDialogComponent,
    ResendInvoicesDialogComponent,
    InvoiceNotFoundDialogComponent,
    ReleaseInvoicesDialogComponent,
    ResendClosedInvoicesDialogComponent
  ],
})
export class DialogsModule {}
